// import lottie from "./components/lottie";
import text from "./components/text";
import {
	heroVid,
	videoPlay,
	autoplayVideo,
	videoHover,
	videoHero,
	playMouseFollow,
} from "./components/video";
import projectCarousel from "./components/carousel";
import pagination from "./components/pagination";
import {
	customColours,
	projectGrid,
	projectProximityCursor,
} from "./components/projects";
import { linkArrow, imageAni, fadeAni } from "./components/animation";
import { scrollTo, moveOnScrollY, moveOnScrollX } from "./components/scroll";
import { cursorMagnet, circleIconHover } from "./components/mouse";
import selectProjects from "./components/select";

export const containerInit = () => {
	// text
	text.init();
	// video
	heroVid.init();
	videoPlay.init();
	videoHover.init();
	videoHero.init();
	autoplayVideo.init();
	playMouseFollow.init();
	// scroll
	scrollTo.init();
	moveOnScrollY.init();
	moveOnScrollX.init();
	// projects
	customColours.init();
	projectGrid.init();
	projectProximityCursor.init();
	// pagination
	pagination.init();
	// carousel
	projectCarousel.init();
	// animation
	linkArrow.init();
	imageAni.init();
	fadeAni.init();
	// mouse
	cursorMagnet.init();
	circleIconHover.init();
	selectProjects.init();
};
export const init = () => {
	containerInit();
};
